var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "preview-url-qrcode" }, [_vm.url ? [_vm.title ? _c('p', { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('qrcode', _vm._b({}, 'qrcode', _vm.qrcodeAttrs, false))] : _vm._e()], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };